// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"570bb414","977":"03479ac8"}[chunkId] + ".chunk.js";
};